module.exports = __webpack_public_path__ + "static/media/two.2c9415fc.jpg";